export default "__VITE_ASSET__GLiyLywU__"